import React, { useState, useEffect } from "react";
import AmsterModal from "../../components/AmsterModal";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
  Stack,
  Fab,
} from "@mui/material";
import { Search, Phone } from "@mui/icons-material";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import experiences from "../../constants/experiences";

const Experiences = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("North goa");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
      offset: 100,
    });
  }, []);

  // Use centralized experiences data
  const properties = experiences;

  // Filter experiences based on search and location
  const filteredProperties = properties.filter((property) => {
    const matchesSearch =
      property.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLocation =
      selectedLocation === "North goa"
        ? property.location === "North Goa"
        : property.location === "South Goa";
    return matchesSearch && matchesLocation;
  });

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
  };

  // Remove navigation on card click
  // const handlePropertyClick = (propertyId) => {
  //   navigate(`/experience/${propertyId}`);
  // }

  return (
    <>
      <Navbar />
      <Box sx={{ py: 8 }}>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
          >
            {/* Header Section */}
            <Typography
              variant="h2"
              data-aos="fade-up"
              sx={{
                fontFamily: "Monument-Private",
                fontWeight: 700,
                fontSize: { xs: "2.5rem", md: "4rem" },
                mb: 4,
                color: "#000",
              }}
            >
              Experiences in Goa
            </Typography>

            {/* Search Bar */}
            <Box sx={{ maxWidth: "600px", mb: 4 }}>
              <TextField
                fullWidth
                placeholder="Search experiences"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                data-aos="fade-up"
                data-aos-delay="100"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: "#666", fontSize: "1.2rem" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "50px",
                    backgroundColor: "#e8e9ea",
                    pr: 12,
                    border: "none",
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                    "& input": {
                      py: 2,
                      fontSize: "1rem",
                    },
                  },
                }}
              />
            </Box>
          </Stack>

          {/* Experiences Grid */}
          <Grid container spacing={4}>
            {filteredProperties.map((property, index) => (
              <Grid
                item
                size={{ xs: 12, md: 6, lg: 4 }}
                key={property.id}
                sx={{ display: "flex" }}
              >
                <Card
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  onClick={() => setOpenModal(true)}
                  sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    position: "relative",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 8px 40px rgba(0, 0, 0, 0.12)",
                    },
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      height="280"
                      image={property.image}
                      alt={property.name}
                      sx={{
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  <CardContent sx={{ p: 3, flexGrow: 1 }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontFamily: "Monument-Private",
                        fontWeight: 600,
                        fontSize: "1.5rem",
                        color: "#000",
                      }}
                    >
                      {property.name}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#666",
                        lineHeight: 1.6,
                        fontSize: "0.95rem",
                      }}
                    >
                      {property.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* No Results Message */}
          {filteredProperties.length === 0 && (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <Typography
                variant="h5"
                sx={{
                  color: "#666",
                  fontWeight: 500,
                  mb: 2,
                }}
              >
                No experiences found
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#999",
                }}
              >
                Try adjusting your search or location filter
              </Typography>
            </Box>
          )}
        </Container>
      </Box>
      <Footer />

      {/* Amster Modal */}
      <AmsterModal open={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};

export default Experiences;
